import moment from "moment";
import "moment/locale/ar-ly";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/ja";
import "moment/locale/pt";
import "moment/locale/ru";
import "moment/locale/zh-cn";

// "ar" writes Eastern Arabic digits, even in `format("YYYY-MM-DD")`: dates sent to a server or read back as dates break.
// "ar-ly" is the same Arabic with the digits 0-9. Moment has no "zh" of its own.
const MOMENT_LOCALES: Record<string, string> = { ar: "ar-ly", zh: "zh-cn" };

export const momentLocaleOf = (language?: string | null): string => {
  const lang = (language || "en").split("-")[0];
  return MOMENT_LOCALES[lang] ?? lang;
};

// Each import above calls moment.defineLocale, which also switches the global locale.
moment.locale("en");
